// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3570U","title":"ClientInsurance_title__3vr7W","itemText":"ClientInsurance_itemText__23G-8"};